import { useEffect } from 'react'
import { useWatch } from 'react-hook-form'

import { TaxReceiptType as TaxReceiptTypeEnum } from '@/entities/user'
import { useEnhancedFormContext, useScrollState } from '@/shared/lib'
import { Form, Separator, ContentBox } from '@/shared/ui'

import { CashReceiptBusinessField } from './cash-receipt-business'
import { CashReceiptPersonalField } from './cash-receipt-personal'
import { TaxInvoiceFields } from './tax-invoice'
import { RECEIPT_INFORMATION_FIELDS } from '../model/form'

type Props = {
  scrollBlock?: ScrollLogicalPosition
}

export const TaxReceiptType = ({ scrollBlock = 'end' }: Props) => {
  const { control, clearErrors, setFocus } = useEnhancedFormContext()

  const { ref, scrollIntoView } = useScrollState<HTMLDivElement>()

  const taxReceiptType = useWatch({
    name: 'taxReceiptType',
    control,
  })

  const handleTaxReceiptTypeChange = () => {
    clearErrors(RECEIPT_INFORMATION_FIELDS)

    setTimeout(() => {
      scrollIntoView({ block: scrollBlock, behavior: 'smooth' })
    }, 0)
  }

  useEffect(() => {
    if (taxReceiptType === TaxReceiptTypeEnum.CASH_RECEIPT_PERSONAL) {
      setFocus('personalIssuanceNumber')
    } else if (taxReceiptType === TaxReceiptTypeEnum.CASH_RECEIPT_BUSINESS) {
      setFocus('businessIssuanceNumber')
    } else if (taxReceiptType === TaxReceiptTypeEnum.TAX_INVOICE) {
      setFocus('corpId')
    }
  }, [taxReceiptType, setFocus])

  return (
    <ContentBox
      spacing="medium"
      color="light-gray"
      className="space-y-6"
      ref={ref}
    >
      <Form.Field name="taxReceiptType">
        <Form.RadioGroup
          className="flex-col gap-4"
          onChange={handleTaxReceiptTypeChange}
        >
          <Form.Radio value={TaxReceiptTypeEnum.CASH_RECEIPT_PERSONAL}>
            개인소득공제용 현금영수증
          </Form.Radio>
          <Form.Radio value={TaxReceiptTypeEnum.CASH_RECEIPT_BUSINESS}>
            사업자증빙용 현금영수증
          </Form.Radio>
          <Form.Radio value={TaxReceiptTypeEnum.TAX_INVOICE}>
            전자세금계산서
          </Form.Radio>
        </Form.RadioGroup>
      </Form.Field>
      <Separator />

      {taxReceiptType === TaxReceiptTypeEnum.CASH_RECEIPT_PERSONAL && (
        <CashReceiptPersonalField />
      )}
      {taxReceiptType === TaxReceiptTypeEnum.CASH_RECEIPT_BUSINESS && (
        <CashReceiptBusinessField />
      )}
      {taxReceiptType === TaxReceiptTypeEnum.TAX_INVOICE && (
        <TaxInvoiceFields />
      )}
    </ContentBox>
  )
}
